import React from "react";
import {
	Dialog,
	DialogContent,
	Button,
	DialogTitle,
	DialogContentText,
	DialogActions,
} from "@mui/material";

import "./error-popup.css";
import SCLabel from "src/components/atoms/sc-label/sc-label";

interface ErrorPopupProps {
	open: boolean;
	onClose?: () => void;
	message?: string;
	maxWidth?: string;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ open, onClose, message }) => {
	return (
		<React.Fragment>
			<Dialog
				open={open}
				onClose={onClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title" color="error">
					{"Processing error"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						An error occurred while processing your request. Please
						try again later. If the problem persists, contact
						support for assistance.
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onClose} autoFocus>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};

export default ErrorPopup;
